import { apiSlice } from "../stores/base/api-slice";
import { NotificationFilter, BroadcastNotificationDetail, BroadcastNotificationSubType, MyBroadcastNotificationsResponse, PaginatedNotificationsResponse, SignalRNegotiateResponse, UserNotification } from "../model/notifications/notifications";

const notificationEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		signalRNegotiate: builder.query<SignalRNegotiateResponse, void>({
			query: () => ({
				url: "/notification/push/negotiate",
				method: "GET",
			}),
		}),
		getMyNotifications: builder.query<PaginatedNotificationsResponse, { page: number; pageSize: number; notificationFilter: NotificationFilter }>({
			query: ({ page, pageSize, notificationFilter }) => ({
				url: "/notification/push/getMyNotifications",
				method: "POST",
				body: { page, pageSize, notificationFilter },
			}),
			providesTags: ["Notifications"],
		}),
		getNotificationById: builder.query<UserNotification, { id: string }>({
			query: ({ id }) => ({
				url: `/notification/push/getNotificationById/${id}`,
				method: "GET",
			}),
		}),
		getUnreadNotificationsCount: builder.query<number, void>({
			query: () => ({
				url: "/notification/push/getMyNotificationsCount",
				method: "GET",
			}),
		}),
		getMyBroadcastNotifications: builder.query<MyBroadcastNotificationsResponse, { isOnLogin: boolean }>({
			query: ({ isOnLogin }) => ({
				url: '/notification/broadcast/getMyNotifications',
				method: 'GET',
				params: { isOnLogin },
			}),
			providesTags: ['BroadcastNotifications'],
		}),
		getBroadcastNotificationsByType: builder.query<UserNotification[], { type: BroadcastNotificationSubType }>({
			query: ({ type }) => ({
				url: '/notification/broadcast/broadcastByType',
				method: 'GET',
				params: { type },
			}),
			providesTags: ['BroadcastNotifications'],
		}),
		createBroadcastNotification: builder.mutation<void, FormData>({
			query: (formData) => ({
				url: '/notification/broadcast',
				method: 'POST',
				body: formData,
			}),
			invalidatesTags: ['BroadcastNotifications'],
		}),
		getBroadcastNotificationDetail: builder.query<BroadcastNotificationDetail, { type: BroadcastNotificationSubType }>({
			query: ({ type }) => ({
				url: '/notification/broadcast/getBroadcastNotificationByType',
				method: 'GET',
				params: { type },
			}),
			providesTags: ['BroadcastNotificationDetail'],
		}),
		editBroadcastNotification: builder.mutation<void, { notificationId: string; formData: FormData }>({
			query: ({ notificationId, formData }) => ({
				url: '/notification/broadcast',
				method: 'PUT',
				params: { notificationId },
				body: formData,
			}),
			invalidatesTags: ['BroadcastNotificationDetail'],
		}),
		setBroadcastDontShowAgain: builder.mutation<void, { notificationId: string; dontShowAgain: boolean }>({
			query: ({ notificationId, dontShowAgain }) => ({
				url: `/notification/broadcast/dontShowAgain?notificationId=${notificationId}`,
				method: 'PUT',
				body: {'dontShowAgain': dontShowAgain},
			}),
		}),
		deleteBroadcastNotification: builder.mutation<void, { notificationId: string }>({
			query: ({ notificationId }) => ({
				url: '/notification/broadcast',
				method: 'DELETE',
				params: { notificationId },
			}),
			invalidatesTags: ['BroadcastNotifications'],
		}),
	}),
});

export const { useLazySignalRNegotiateQuery, useLazyGetMyNotificationsQuery, useGetMyNotificationsQuery, useLazyGetNotificationByIdQuery, useGetUnreadNotificationsCountQuery, useLazyGetUnreadNotificationsCountQuery, useGetMyBroadcastNotificationsQuery, useLazyGetMyBroadcastNotificationsQuery, useGetBroadcastNotificationsByTypeQuery, useLazyGetBroadcastNotificationsByTypeQuery, useCreateBroadcastNotificationMutation, useEditBroadcastNotificationMutation, useDeleteBroadcastNotificationMutation, useLazyGetBroadcastNotificationDetailQuery, useSetBroadcastDontShowAgainMutation } = notificationEndpoints;
export const notificationApi = notificationEndpoints;